'use client';

import type { Raffle } from '@/types/models/Raffle';

import { RaffleCard } from '../RaffleCard';

type RafflesListProps = {
  raffles: Raffle[];
};

export const RafflesList = ({
  raffles,
  ...props
}: RafflesListProps & { 'data-cy'?: string }) => {
  if (!raffles || raffles.length === 0) return null;

  return (
    <div data-cy={props['data-cy'] || 'raffles-list'} className="space-y-4">
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {raffles.map((raffle) => (
          <RaffleCard key={raffle.id} raffle={raffle} />
        ))}
      </div>
    </div>
  );
};
